export default function AttendanceIcon(){
    return(
        <>
         <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width={18}
                      height={18}
                      x={0}
                      y={0}
                      viewBox="0 0 66 66"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      xmlSpace="preserve"
                      className=""
                    >
                      <g>
                        <path
                          d="M62.5.7h-59c-1.6 0-3 1.3-3 3v51.6c0 1.6 1.3 3 3 3h6.7v6c0 .6.4 1 1 1s1-.4 1-1V56h13.7v8.3c0 .6.4 1 1 1s1-.4 1-1v-6h34.6c1.6 0 3-1.3 3-3V3.7c0-1.6-1.3-3-3-3zM12.2 54v-1.8c0-.4-.2-.7-.5-.9l-3.9-2.2V44l2.4-1.4V45c0 .6.4 1 1 1s1-.4 1-1V26.5c0-.4.4-1 1-1 .5 0 1 .4 1 1V39.4c0 .6.4 1 1 1 .3 0 .5-.1.7-.3s.3-.4.3-.7v-4.5c0-.5.4-1 1-1 .5 0 1 .4 1 1v4.5c0 .6.4 1 1 1s1-.4 1-1v-4.5c0-.5.4-1 1-1 .5 0 1 .4 1 1v4.5c0 .6.4 1 1 1s1-.4 1-1v-4.5c0-.5.4-1 1-1 .5 0 1 .4 1 1V54zM7.6 7.7h11.2v4H7.6zm0 6h11.2v14.6h-2.6v-1.8c0-1.7-1.4-3-3-3-1.7 0-3 1.5-3 3v1.8H7.6zm55.9 41.6c0 .5-.4 1-1 1H27.9V34.9c0-1.6-1.3-3-3-3-.8 0-1.4.3-2 .8-.5-.5-1.2-.8-2-.8s-1.4.3-2 .8c-.5-.5-1.2-.8-2-.8-.3 0-.7.1-1 .2v-1.8h3.6c.6 0 1-.4 1-1V6.7c0-.6-.4-1-1-1H6.6c-.4 0-.8.3-.9.6-.1.2-.1.3-.1.4v22.5c0 .6.4 1 1 1h3.6v9.9l-3.9 2.4c-.3.2-.5.5-.5.9v6.2c0 .4.2.7.5.9l3.9 2.2v3.6H3.5c-.5 0-1-.4-1-1V3.7c0-.5.4-1 1-1h59c.5 0 1 .4 1 1z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                        <path
                          d="M59.5 5.7H30.7c-.6 0-1 .4-1 1v14.2c0 .6.4 1 1 1h28.8c.6 0 1-.4 1-1V6.7c0-.5-.4-1-1-1zm-1 14.2H31.7V7.7h26.8zM38.3 28.3h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1s-.5-1-1-1zM57.3 28.3h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1s-.4-1-1-1zM47.8 28.3h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1s-.4-1-1-1zM38.3 38.7h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.5-1-1-1zM57.3 38.7h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.4-1-1-1zM47.8 38.7h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.4-1-1-1zM38.3 49.2h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.5-1-1-1zM57.3 49.2h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.4-1-1-1zM47.8 49.2h-5.4c-.6 0-1 .4-1 1s.4 1 1 1h5.4c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                        <path
                          d="M34.1 17.2h4.8c.6 0 1-.4 1-1v-4.8c0-.6-.4-1-1-1h-4.8c-.6 0-1 .4-1 1v4.8c0 .5.4 1 1 1zm1-4.8h2.8v2.8h-2.8zM42.7 17.2h4.8c.6 0 1-.4 1-1v-4.8c0-.6-.4-1-1-1h-4.8c-.6 0-1 .4-1 1v4.8c0 .5.5 1 1 1zm1-4.8h2.8v2.8h-2.8zM51.4 17.2h4.8c.6 0 1-.4 1-1v-4.8c0-.6-.4-1-1-1h-4.8c-.6 0-1 .4-1 1v4.8c0 .5.4 1 1 1zm1-4.8h2.8v2.8h-2.8z"
                          fill="#000000"
                          opacity={1}
                          data-original="#000000"
                          className=""
                        />
                      </g>
                    </svg>
        </>
    )
}
